export function roundToDecimal(value, decimalPlaces = 1) {
  switch (value) {
    case "-":
    case "":
    case undefined:
    case null:
      return "-";

    default: {
      const floatValue = Number.parseFloat(value);
      if (
        typeof Number(floatValue) === "number" &&
        !Number.isNaN(Number(floatValue))
      ) {
        const factor = 10 ** decimalPlaces;
        const roundedValue = (Math.ceil(floatValue * factor) / factor)
          .toFixed(decimalPlaces)
          .toString();
        return roundedValue;
      }
      return value;
    }
  }
}
